'use strict';

export const faqUrls = {
  dev: 'https://content-dev.meinkontowechsel.de/api',
  testing: 'https://content-testing.meinkontowechsel.de/api',
  production: 'https://content.meinkontowechsel.de/api'
};



// WEBPACK FOOTER //
// ./src/app/common/ui/faq/faq.constants.js